module.exports = __webpack_public_path__ + "static/media/reset-pwd-right-ellipse.4725f5dd.png";